<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.132"
    height="13.949"
    viewBox="0 0 19.132 13.949"
  >
    <g
      id="Group_11185"
      data-name="Group 11185"
      transform="translate(197.505 -21.025) rotate(90)"
    >
      <rect
        id="Rectangle_186"
        data-name="Rectangle 186"
        width="13.948"
        height="2.79"
        transform="translate(21.025 194.715)"
      />
      <rect
        id="Rectangle_187"
        data-name="Rectangle 187"
        width="9.066"
        height="2.79"
        transform="translate(21.025 197.505) rotate(-90)"
      />
      <rect
        id="Rectangle_188"
        data-name="Rectangle 188"
        width="9.066"
        height="2.79"
        transform="translate(32.185 197.505) rotate(-90)"
      />
      <path
        id="Path_1116"
        data-name="Path 1116"
        d="M0,0V6.625H6.625"
        transform="translate(32.684 185.18) rotate(135)"
        stroke-width="3"
      />
      <line
        id="Line_47"
        data-name="Line 47"
        y1="8.976"
        transform="translate(28 181.462)"
        stroke-width="3"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ExportIcon',
};
</script>
<style scoped lang="scss">
svg {
  margin-left: 8px;
}
</style>
